import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { MiddlePanelConstant, StringConstants,CharConstants,SHOW_PROPERTY_TIMEZONE_DATE_FIELD } from "../../../../containers/WorkkardDetail/constants";
import { fetchDateFormatByTimezone,fetchTimezoneAbbreviation,checkAndShowDateFieldValueAccToWorkkardTz, abbreviationName, currencyFormatterWithAddAmount } from '../../../../common/util';
import Icons from '../../../../icons';
import { useModules } from '../../../../utils/modules';
import { showTooltip } from "../../../../containers/WorkkardDetail/actions/action";
import { DEFAULT_TIME_FORMAT, DEFAULT_DATE_FORMAT } from '../../../../common/constants';
import { selectSessionContextOidc } from '@container/AdminPanel/features/users/usersSelectors';
import { selectOrgById } from '../../../../common/slice/orgList';

const moment = require('moment-timezone');

const NoteData = (props) => {
    const { isModuleEnabled } = useModules();
    const dispatch = useDispatch();
    const middlePanel = useSelector(state => state.workkardDetail.middlePanel);
    const activityDetail = useSelector(state => state.workkardDetail.activityDetail);
    const globalSearch = useSelector(state => state.header.globalSearch.activeTab);
    const workkardDetail = useSelector(state => state.workkardDetail.workkardDetail);
    const sessionContext = useSelector(selectSessionContextOidc);
    const userList = useSelector(state => state.userList);
    const cachedUser = userList?.[props.data.CreatedBy];
    const noteOrg = useSelector(selectOrgById(props.data.OrganizationId));
    const userView = sessionContext?.userView;

    const fullNameOf = (user) => user
        ? `${user.first_name || user.firstName || ''} ${user.last_name || user.lastName || ''}`.trim()
        : '';

    const displayName = props.data.Name || fullNameOf(cachedUser);
    const displayOrgName = noteOrg?.name
        || props.data.OrganizationName
        || cachedUser?.organization_name
        || cachedUser?.organizationName
        // The note payload carries no organization name, so a note authored in the
        // caller's own organization falls back to the loaded organization view.
        || (props.data.OrganizationId === userView?.orgId
            ? (sessionContext?.organizationView?.Name || sessionContext?.organizationView?.name || '')
            : '');
    const isUserActiveResolved = props.data.IsUserActive
        || cachedUser?.is_active === true
        || cachedUser?.isActive === true;

    // Reviewer and publisher arrive as user ids; resolve them the same way.
    const reviewedByName = props.data.ReviewedBy
        || fullNameOf(userList?.[props.data.ReviewerId]);
    const publishedByName = props.data.PublishedBy
        || fullNameOf(userList?.[props.data.PublisherId]);
    const createdTime = (props.data.PrettyCreatedDate || '').split('at')[1] || '';


    const noteOrderListRef = React.useRef([]);

    const [review, setReview] = React.useState('');
    const [actionMenuVisible, setActionMenuVisible] = React.useState(false);
    const [reviewErrorText, setReviewErrorText] = React.useState(false);
    const [reviewLength, setReviewLength] = React.useState(100);
    const [actionIcon, setActionIcon] = React.useState(false);
    const [customFieldGroupedData, setCustomFieldGroupedData] = React.useState([]);

    const reviewPermission = (data) => {
        const reviewFormOpen = data.IsReviewed !== null && props.reviewId === data.Id;
        return Boolean(
            data.CanReviewNote &&
            !reviewFormOpen &&
            middlePanel.notes.type.toLowerCase() == StringConstants.activity
        );
    };


    const publishPermission = (data) => {
        if (!data.CanPublishNote) return false;
        return Boolean(
            (middlePanel.notes.type.toLowerCase() == StringConstants.workkard) ||
            (middlePanel.notes.type.toLowerCase() == StringConstants.activity &&
            activityDetail.status &&
            activityDetail.status.toLowerCase() !== 'close' &&
            activityDetail.resolution &&
            activityDetail.resolution.toLowerCase() !== 'rejected')
        );
    };

    const deleteNotePermission = (data) => Boolean(data.CanDeleteNote);

    const cloneNotePermission = (data) => Boolean(data.CanCloneNote);


    const actionIconPermission = (data) => {
        setActionIcon(
            reviewPermission(data) ||
            publishPermission(data) ||
            deleteNotePermission(data) ||
            cloneNotePermission(data)
        );
    };

    React.useEffect(() => {
        actionIconPermission(props.data);
        if (props.data.ActivityNoteCustomFieldViews) {
            const fieldsData = props.data.ActivityNoteCustomFieldViews;
            // Wrap each element in its own array with
            const wrapped = fieldsData.map((item) => [item]); 
            setCustomFieldGroupedData(wrapped);
        }
    }, [props.data, props.reviewId]);

    const clickActionMenu = () => {
        setActionMenuVisible(prev => !prev);
    };

    const validateReviewText = (id) => {
        if (review != null && review.trim() != "") {
            props.reviewSubmit(id, review.toString().trim());
            actionIconPermission(props.data);
        } else {
            setReviewErrorText(true);
        }
    };

    const resetReviewValidation = () => {
        setReviewErrorText(false);
        setReviewLength(100);
        props.onReviewClick(null);
    };

    const openTooltip = (event, data) => {
        dispatch(showTooltip({
            target: event.target.getBoundingClientRect(),
            hideOnDocClick: false,
            childComponent: <span>{data}</span>
        }));
    };

    const handleReviewClick = (id) => {
        setActionMenuVisible(false);
        props.onReviewClick(id);
    };

    const handleReviewChange = (e) => {
        setReview(e.target.value);
        setReviewLength(100 - e.target.value.length);
    };

    const checkOrderOfPublish = (data) => {
        noteOrderListRef.current = [];
        if (data.InternalToPublic && !data.IsReviewed) {
            noteOrderListRef.current.push("Published");
        } else if (!data.InternalToPublic && data.IsReviewed) {
            noteOrderListRef.current.push("Reviewed");
        } else if (data.InternalToPublic && data.IsReviewed) {
            if (data.UpdatedDateEpoch <= data.ReviewedDateEpoch) {
                noteOrderListRef.current.push("Reviewed");
                noteOrderListRef.current.push("Published");
            } else {
                noteOrderListRef.current.push("Published");
                noteOrderListRef.current.push("Reviewed");
            }
        }
        return true;
    };

    const displayValue = (field, workkardTz, userTimezone, fieldTimeFormat, listOfTimeZone) => {
        if (workkardTz == undefined || workkardTz == null || workkardTz == '') {
            let propertTz = (workkardDetail?.CustomFields.some(obj => obj.FieldKey == "policyeffectivedate_timezone")) ? workkardDetail.CustomFields.filter(item => item.FieldKey == "policyeffectivedate_timezone")[0].Value : "";
            workkardTz = propertTz != "" && listOfTimeZone.length > 0 ? listOfTimeZone.filter(item => item.DisplayText == propertTz)[0].UniversalTimeZoneId : userTimezone;
        }
        let UserTzDateFielValue = fetchDateFormatByTimezone(field.Value, workkardTz, userTimezone).format(fieldTimeFormat);
        let dateFieldsLabel = SHOW_PROPERTY_TIMEZONE_DATE_FIELD.map(item => item.toLowerCase());
        let workkardTzDateFieldValue = checkAndShowDateFieldValueAccToWorkkardTz(field.Value, dateFieldsLabel, (field.Label || '').toLowerCase(), userTimezone, workkardTz, listOfTimeZone, fieldTimeFormat);
        if (workkardTzDateFieldValue != '') {
            let combinedValue = `${UserTzDateFielValue} ${workkardTzDateFieldValue}`;
            return combinedValue;
        }
        return UserTzDateFielValue;
    };

    const getClassforNoteTemplateCf = (data) => {
        return data.length > 0 && data.length <= 2 ? "col-2 col-2-only mb" : "col-3 col-3-only mb";
    };

    const checkForCombineCustomField = (item) => {
        if (item.some(x => x.FieldKey.includes("datetime") && (x.Value == "" || x.Value == null))) {
            return false;
        }
        if (item.some(x => x.FieldKey.includes("string") && (x.Value == "" || x.Value == null))) {
            return false;
        }
        if (item.some(x => x.FieldKey.includes("decimal") && (x.Value == "" || x.Value == null))) {
            return false;
        }
        return true;
    };

    const { data } = props;
    return (
        <div onMouseLeave={() => { setActionMenuVisible(false); }} >
            {
                !data.IsReviewed && props.reviewId == data.Id &&
                <>
                    <div className="reviewNote rowFlex alignMiddle" >
                        <div className="reviewCommentBox rowFlex formGroup mrNone">
                            <input type="text" placeholder={MiddlePanelConstant.Note.ReviewNotePlaceholder} maxLength="100" onChange={handleReviewChange} />
                            <label className="reviewCounter">{reviewLength}</label>
                        </div>
                        <a className="mr ml" href="javascript:void(0);" onClick={() => validateReviewText(data.Id)}>
                            Confirm
                        </a>
                        <a className="reviewClick" href="javascript:void(0);" onClick={resetReviewValidation}>Cancel</a>
                    </div>
                    {reviewErrorText && <span className="errorSelfMsg">Please add review text</span>}
                </>
            }

            {checkOrderOfPublish(data) && noteOrderListRef.current.map((item) => {
                return (
                    <React.Fragment key={item}>
                    {item == "Reviewed" && ((data.IsReviewed && (activityDetail.ownerOrgId == userView?.orgId || activityDetail.assigneeOrgId == userView?.orgId)) || (data.IsReviewed && sessionContext.accessToOrgIds.includes(data.OrganizationId) && data.iswkshared == false)) &&
                        <div className="reviewNoteAdded selfStart rowSpaceBetween">
                            <Icons name="review" className="icon mr" />
                            <div className="colFlex">
                                <label className="alignMiddle flexWrap">
                                    <span className='alignMiddle'>
                                        {MiddlePanelConstant.Note.ReviewedByText}
                                        <span className="ml mr black">{reviewedByName}</span>
                                    </span>
                                         on {data.ReviewedDateString}

                                </label>
                                <em>{data.NoteReason}</em>
                            </div>
                        </div>
                    }
                    {item == "Published" && ((data.InternalToPublic && (activityDetail.ownerOrgId == userView?.orgId || activityDetail.assigneeOrgId == userView?.orgId)) && data.OrganizationId == userView?.orgId || (data.InternalToPublic && sessionContext.accessToOrgIds.includes(data.OrganizationId) && !data.iswkshared)) &&
                        <div className="publishNotesAdded alignMiddle">
                            <Icons name="public" className="icon mr" />
                            <label>{MiddlePanelConstant.Note.PublishedByText}
                                <span className="mr black">{publishedByName}</span>from Internal to Public on {data.PublishedDateString}
                            </label>
                        </div>
                    }
                    </React.Fragment>
                );
            })}

            <div className="rowSpaceBetween mb mb__8">
                <span className="userInfo flexWrap alignMiddle">{displayName}{!isUserActiveResolved && ( <span class="gray ml"> (Inactive)</span>)} <span className="mr__4 ml__4">&ndash;</span> <span onMouseEnter={(e) => openTooltip(e, displayOrgName)}>{abbreviationName(displayOrgName)}</span> <span className="dateTime"> <label className="mrNone">{createdTime}</label> </span>
                {
                    (globalSearch == 2) &&
                    <>
                        <a href={`/getclmdetail?cId=${data.workkardId}`} className="rowFlex alignMiddle">
                            <span className="badges wkSymbol mr ml__12">{CharConstants.Workkard}</span>
                            <span className="status wkNumber">{data.WorkkardNumber}</span>
                        </a>
                        {
                            data.ActivityTitle &&
                            <a href={`/getclmdetail?cId=${data.workkardId}&actId=${data.activityId}`} className="alignMiddle">
                                <span className="badges actSymbol mr ml__12">{CharConstants.Activity}</span>
                                <span className="mr">{data.ActivityTitle}</span>
                            </a>
                        }
                    </>
                }
                {data.NoteTemplateName == 'Time Demand' &&
                    <span className="status ml quickTooltip-right" data-quicktooltip="High priority"><Icons name="flag" className="icon" /></span>
                }</span>

                <div className="alignMiddle notesAction">
                    <span className={`status mr ${(globalSearch != 2) && 'animated superFaster delay-5'}' ${data?.Type.replace('Personal', 'Draft').toLowerCase()}`}>{data?.Type.replace('Personal', 'Draft')}</span>
                    {
                        (globalSearch != 2) && !sessionContext.isAuditUser &&
                        <div className={`dropDown h__24 noteAction animated superFaster ${actionMenuVisible ? "active" : ""}`}>
                            {actionIcon && <span className="icon" onClick={clickActionMenu}><Icons name="more" className="icon more" /></span>}
                            <div className={actionMenuVisible ? "dropDownMenu openRight onClick" : "dropDownMenu openRight"}>
                                {
                                    reviewPermission(data) && isModuleEnabled("notes.review") &&
                                    <a href="javascript:void(0)" onClick={() => handleReviewClick(data.Id)}><Icons name="review" className="icon mr" /> {MiddlePanelConstant.Note.ReviewButtonText}</a>
                                }
                                {
                                    publishPermission(data) && isModuleEnabled("notes.publish") &&
                                    <a href="javascript:void(0)" className="internalToPublic" onClick={() => { props.onPublishClick(data.Id, data.Type); actionIconPermission(props.data); }}><Icons name="public" className="icon mr" /> {MiddlePanelConstant.Note.PublishButtonText}</a>
                                }
                                {
                                    deleteNotePermission(data) && isModuleEnabled("notes.delete") && <a href="javascript:void(0)" onClick={() => { props.onDeleteNoteClick(data.Id); actionIconPermission(props.data); }}><Icons name="delete" className="icon mr" /> {MiddlePanelConstant.Note.DeleteButtonText}</a>
                                }
                                {/* {
                                    editNotePermission(data) && <a href="javascript:void(0)" onClick={() => { props.onEditNoteClick(data.Id); actionIconPermission(props.data); }}><Icons name="edit" className="icon mr" /> {MiddlePanelConstant.Note.EditButtonText}</a>
                                } */}
                                {
                                    cloneNotePermission(data) && isModuleEnabled("notes.clone_note") && <a href="javascript:void(0)" className="cloneNote" onClick={() => { props.onCloneNoteClick(data.Id); actionIconPermission(props.data); }}><Icons name="clone" className="icon mr" /> {MiddlePanelConstant.Note.CloneButtonText}</a>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
            {
                (!data.IsNoteTemplateDefault && data.NoteTemplateName && data.NoteTemplateName != "File Note") &&
                <span className="note_tmpl_type">
                    <label>{data.NoteTemplateName}</label>
                </span>
            }
            {
                data.ActivityNoteCustomFieldViews && data.ActivityNoteCustomFieldViews.length > 0 &&
                <div className={getClassforNoteTemplateCf(customFieldGroupedData)}>
                    <ul className="flexGrow">
                        {
                            customFieldGroupedData.map((item, key) => {
                                const fieldGroup = item[0].Label;
                                return ((item.length > 1 && checkForCombineCustomField(item)) || (item.length == 1 && item[0].Value != "" && item[0].Value != null)) ?
                                <li key={key}>
                                    {item.length > 1 && <label>{fieldGroup}</label>}
                                    <span>
                                        {
                                            item.map(field => {
                                                const fieldSetting = field.FieldSettings ? JSON.parse(field.FieldSettings) : {};
                                                if (field.Value && field.Value.trim() != "" && field.FieldKey.includes("_multiplechoicelist_") && field.Value != null) {
                                                    return (<React.Fragment key={field.FieldKey}><label className="muliple_choice">{field.Label} </label>
                                                                <span className="mr">{field.Value.split(',').join(', ')}</span></React.Fragment>);
                                                } else if (field.Value && field.Value.trim() != "" && field.Value != null) {
                                                    if (item.length > 1) {
                                                        if (field.FieldKey.includes("timezone")) {
                                                            return fieldSetting.output_timezone_component ? <span key={field.FieldKey} className="mr">{fetchTimezoneAbbreviation(field.Value)}</span> : null;
                                                        } else if (field.FieldKey.includes("datetime")) {
                                                            const fieldTimeFormat = fieldSetting.output_time_component ? DEFAULT_TIME_FORMAT : DEFAULT_DATE_FORMAT;
                                                            const timezoneField = item.find(x => x.FieldKey.includes("timezone"));
                                                            const timeZoneDisplayText = timezoneField ? timezoneField.Value : "";
                                                            const tzMatch = timeZoneDisplayText != "" && timeZoneDisplayText != null
                                                                ? sessionContext.tzData.find(tz => tz.DisplayText == timeZoneDisplayText)
                                                                : null;
                                                            const customFieldTimezoneId = tzMatch ? tzMatch.UniversalTimeZoneId : "";
                                                            const outputToTimezone = fieldSetting.output_to_timezone || "";
                                                            const parsedNumericValue = Number(field.Value);
                                                            const parsedMoment = Number.isFinite(parsedNumericValue)
                                                                ? moment.unix(parsedNumericValue).utc()
                                                                : moment.utc(field.Value);
                                                            return outputToTimezone.includes("user") && sessionContext.TimeZoneTz !== undefined ?
                                                            <span key={field.FieldKey} className="mr">{displayValue(field, customFieldTimezoneId, sessionContext.TimeZoneTz, fieldTimeFormat, sessionContext.tzData)}</span> :
                                                            <span key={field.FieldKey} className="mr">{parsedMoment.isValid() ? parsedMoment.format(fieldTimeFormat) : ''}</span>;
                                                        }
                                                    } else {
                                                        return (
                                                            <React.Fragment key={field.FieldKey}>
                                                                <label>{field.FieldGroup}</label>
                                                                <span className="mr">
                                                                    {
                                                                        field?.FieldType === "decimal" ? currencyFormatterWithAddAmount(field.Value) : field.Value
                                                                    }
                                                                </span>
                                                            </React.Fragment>
                                                        );
                                                    }
                                                } else {
                                                    return null;
                                                }
                                            })
                                        }
                                    </span>
                                </li> 
                                : null;
                            })
                        }
                    </ul>
                </div>
            }
        </div>
    );
};

export default NoteData;